import styled from 'styled-components';

export const MainContainer = styled.div`
  flex: 1 0 auto;
  position: relative;
`;
